import { Component, Input } from '@angular/core';

@Component({
  selector: 'lista-blocos-noticias',
  templateUrl: './lista-blocos-noticias.component.html',
  styleUrls: ['./lista-blocos-noticias.component.scss'],
})
export class ListaBlocosNoticiasComponent {
  @Input() noticias;
  @Input() titulo = 'Notícias';
  @Input() botaoVerTodas = true;
}
